import React, { useEffect, useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Topics";
import Select from "react-select";
import { BsDot } from "react-icons/bs";
import { connect } from "react-redux";
import { gain, gain_user } from "../../../store/acion";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import { async } from "@firebase/util";
import { useNavigate, useLocation } from "react-router-dom";
import { doc, setDoc, collection, getFirestore } from "firebase/firestore";
// import { getDatabase, ref, set,push } from "firebase/database";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { width } from "@mui/system";
import { data } from "autoprefixer";
function Dashboard(props) {
  const navigate = useNavigate();

  const [data_gain, setdata_gain] = useState(false);
  const [teacher_data, setteacher_data] = useState([]);
  const location = useLocation();

  const [data_gain_2, setdata_gain_2] = useState(false);
  const [data_filter, setdata_filter] = useState([]);

  const [current_user, setcurrent_user] = useState();

  const select_topic = async (select) => {



    let arr = await props.cbs.filter((e) => e?.topics?.includes(select));

    setdata_gain_2(true);
    setdata_filter(arr);
  };

  const add_request = async (v) => {
    document.getElementById("loading1").style.display = "block";

    const db = getFirestore();
    const today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    let todays = mm + "/" + dd + "/" + yyyy;

    var uniq = "id" + new Date().getTime();
    let { name, pic, email, uid } = current_user;
    await setDoc(doc(db, "request", uniq), {
      teacher_uid: v.uid,
      teacher_name: v.name,
      teacher_email: v.email,
      date: todays,
      meeting_date: "waiting",
      name,
      email,
      pic,
      uid,
      request_uid: uniq,
      new:'yes',
      newUser:'no',
      user_uid:localStorage.getItem('user_uid')
    }).then(() => {
      console.log("successfully");
      toast.success("Your Request For Meeting Send Sucessfully!");

      setTimeout(() => {
        document.getElementById("loading1").style.display = "none";
        // navigate("/Sheduled");

      }, 1800);
    });
  };

  const options = [

    { value: "Other", label: "Other" }
  ];

  const re_load = async () => {
    if (props.cbs == "fail" || props.user == "fail") {
      setdata_gain(false);
      await props.gain_data();
      await props.gain_user();

      console.log("fail>>>>>.");
    } else {

      let asd = await props.user;
      await setcurrent_user(
        await asd.find((e) => e.uid == localStorage.getItem("user_uid"))
      );

      setteacher_data(props.cbs);
      setdata_gain(true);
    }
  };

  useEffect(() => {
    re_load();
  });
  return localStorage.getItem("user_uid") !== null ? (
    <>
      <div class="loading" id="loading1" style={{ display: "none" }}>
        Loading&#8230;
      </div>

      <ToastContainer />

      <Sidebar selectTopic={select_topic} />
      <div className="relative md:ml-64 bg-blueGray-100">
        <Navbar />
        {/* Header */}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-start justify-content-start flex-column">
            <div className="d-flex align-items-start flex-column pb-9" >
              <h1 className="text-white font-semibold text-3xl	 text-center">
                Dashboard
              </h1>
            </div>
            {/* <Select
              className="select_bar"
              onChange={(e) => select_topic(e.value)}
              options={options}
            /> */}
          </div>
        </div>
        <div className="px-4 md:px-10 mx-auto w-full ">
          <div className="flex flex-wrap"></div>
          {data_gain ? (
            <>
              {data_gain_2 ? (
                <div className="mainFlex">
                  {data_filter?.sort((a, b) => b.status.includes('online') - a.status.includes('online'))?.map((v, i) =>
                   {
                    return (
                      <div class="flex justify-center items-center cursor-pointer mainCardBOI">
                      <div class="container flex justify-center containerCard">
                        <div class="bg-white relative shadow-md hover:shadow-xl transition duration-500 rounded-lg containerCard">
                          <img referrerPolicy='no-referrer' className="sameR" src={v.pic} alt="" />
                          <div class="py-2 px-2 rounded-lg bg-white whibi">
                            <h1
                              class="text-lg font-bold ml-2 text-gray-600"
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {v.name} 
                            </h1>
                            <div class="price">
                              <p
                                style={{
                                  
                                  fontWeight: "500",
                                  color: "#643ffe",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  height: 30,
                                }}
                                className='ml-2 text-sm'
                              >
                                  {v.topics?.map((vi)=>{
                                    let length=v.topics.length
                                    return(
                                     <>{vi}{length>1? ",":''} </> 
                                    )
                                  }
                                  
                                )}
                              </p>
                            </div>
                            <button
                              onClick={() => {
                                add_request(v);
                              }}
                              class="mt-3 ml-2 py-2 px-3 mb-2 bg-yellow-400 text-gray-800 font-bold rounded-lg shadow-md hover:shadow-md transition duration-300"
                            >
                              Book Now
                            </button>
                          </div>
                          {v.status=='online'?
                          <div class="absolute top-2 right-2 py-1 px-2 bg-white rounded-lg d-flex flex-row align-items-center justify-content-center">
                          <BsDot
                            size={30}
                            style={{ marginLeft: -9 }}
                            color="#12AD2B"
                          />
                          <span
                            class="text-sm"
                            style={{color:'#12AD2B',marginLeft:-5,fontWeight:'500'}}
                           
                          >
                            {" "}
                            Online
                          </span>
                        </div>:''}
                        </div>
                      </div>
                    </div>
                    );
                  })}
                </div>
              ) : (
                <div className="mainFlex">
                  {
                  
                  teacher_data?.sort((a, b) => b.status.includes('online') - a.status.includes('online'))?.map((v, i) =>
                   {

                    
                    return (
                      <div class="flex justify-center items-center cursor-pointer mainCardBOI">
                        <div class="container flex justify-center containerCard">
                          <div class="bg-white relative shadow-md hover:shadow-xl transition duration-500 rounded-lg containerCard">
                            <img referrerPolicy='no-referrer' className="sameR" src={v.pic} alt="" />
                            <div class="py-2 px-2 rounded-lg bg-white whibi">
                              <h1
                                class="text-lg font-bold ml-2 text-gray-600"
                                style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {v.name} 
                              </h1>
                              <div class="price">
                                <p
                                  style={{
                                    
                                    fontWeight: "500",
                                    color: "#643ffe",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    height: 30,
                                  }}
                                  className='ml-2 text-sm'
                                >
                                  {v?.topics?.map((vi)=>{
                                    let length=v.topics.length
                                    return(
                                     <>{vi}{length>1? ",":''} </> 
                                    )
                                  }
                                  
                                )}
                                </p>
                              </div>
                              <button
                                onClick={() => {
                                  add_request(v);
                                }}
                                class="mt-3 ml-2 py-2 px-3 mb-2 bg-yellow-400 text-gray-800 font-bold rounded-lg shadow-md hover:shadow-md transition duration-300"
                              >
                                Book Now
                              </button>
                            </div>
                            {v.status=='online'?
                            <div class="absolute top-2 right-2 py-1 px-2 bg-white rounded-lg d-flex flex-row align-items-center justify-content-center">
                            <BsDot
                              size={30}
                              style={{ marginLeft: -9 }}
                              color="#12AD2B"
                            />
                            <span
                              class="text-sm"
                              style={{color:'#12AD2B',marginLeft:-5,fontWeight:'500'}}
                             
                            >
                              {" "}
                              Online
                            </span>
                          </div>:''}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}{" "}
            </>
          ) : (
            <div class="loading" id="loading">
              Loading&#8230;
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    navigate("/Login")
  );
}

const mapStateToProps = (state) => {
  return {
    cbs: state.current_stock,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain_data: () => dispatch(gain()),
    gain_user: () => dispatch(gain_user()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
